module.exports = {"id":"230142","name":"Oyarzabal","rating":"79","photo":"./data/images/photos/2/230142.png","club":{"name":"Real Sociedad","logo":"./data/images/clubs/RealSociedad.png"},"positions":["AG","AD","MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Oyarzabal0.json
// module id = 3333
// module chunks = 0